import {Box, Loading} from '@viptech/react-components'
import {useLayoutEffect, useRef, useState} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {useAuth} from 'src/contexts/AuthContext'
import {isEventsRoutePath, isMigratedLegacyPath, isPortalRouteHybridEnabled, navigateToMigratedRouteOnNewPortal} from 'src/lib/portal-migration'
import {isNewPortalEnabledForPath} from 'src/lib/portal-migration/portal-module-prefs'
import {readPortalModulePrefsFromClientCookie} from 'src/lib/portal-migration/portal-module-prefs.client'

const EVENTS_DEEP_LINK_PARAMS = ['id', 'search', 'camera']

function isPastedEventsDeepLink(pathname: string, search: string) {
  if (!isEventsRoutePath(pathname)) return false
  const params = new URLSearchParams(search)
  return EVENTS_DEEP_LINK_PARAMS.some((key) => Boolean(params.get(key)?.trim()))
}

export function MigratedOutlet() {
  const {pathname, search} = useLocation()
  const {isAuth} = useAuth()
  const [bridgeFailed, setBridgeFailed] = useState(false)
  const bridgingRouteKeyRef = useRef<string | null>(null)

  const prefs = readPortalModulePrefsFromClientCookie()
  const forceEventsBridge = isAuth && isPastedEventsDeepLink(pathname, search)
  const hybridBridge = isPortalRouteHybridEnabled() && isAuth && isMigratedLegacyPath(pathname) && isNewPortalEnabledForPath(pathname, prefs)
  const shouldBridge = forceEventsBridge || hybridBridge

  const routeKey = `${pathname}${search}`

  useLayoutEffect(() => {
    if (!shouldBridge || bridgeFailed) return
    if (bridgingRouteKeyRef.current === routeKey) return

    const result = navigateToMigratedRouteOnNewPortal(pathname, search, {forceRedirect: forceEventsBridge})
    if (result.ok) {
      bridgingRouteKeyRef.current = routeKey
    } else {
      setBridgeFailed(true)
    }
  }, [bridgeFailed, forceEventsBridge, pathname, routeKey, search, shouldBridge])

  useLayoutEffect(() => {
    if (!shouldBridge) {
      setBridgeFailed(false)
      bridgingRouteKeyRef.current = null
    }
  }, [shouldBridge])

  if (shouldBridge && !bridgeFailed) {
    return (
      <Box display='flex' justifyContent='center' align='center' minHeight='50vh' aria-busy='true' aria-label='Redirecionando'>
        <Loading size='30px' />
      </Box>
    )
  }

  return <Outlet />
}
